import { render } from "./stronaNotFound.vue?vue&type=template&id=1e1059c6&scoped=true"
import script from "./stronaNotFound.vue?vue&type=script&lang=js"
export * from "./stronaNotFound.vue?vue&type=script&lang=js"

import "./stronaNotFound.vue?vue&type=style&index=0&id=1e1059c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1059c6"]])

export default __exports__